// DashboardCard.tsx
import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import icons from "../../../assets/images/dashboard_icons.png";

interface DashboardCardProps {
  title: string;
  count: number;
  dashboardVal?: any;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  count,
  dashboardVal,
}) => {
  return (
    <Card
      sx={{
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        p: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        border:'0px'
        // minHeight: 100,
      }}
    >
        <Typography
          variant="subtitle2"
          color="#111827"
           sx={{
          fontWeight: 700,
          borderBottom: "2px solid #e5e7eb",
          pb: 0.5,
          mb: 1.5,
        }}
        >
          {title}
        </Typography>
       {/* Bottom Row: number + delta */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ color: "#2e968f" }}>
          {count}
        </Typography>
        {/* {typeof delta === "number" && (
          <Typography
            variant="body2"
            sx={{
              fontWeight: 700,
              color: delta >= 0 ? "green" : "red",
            }}
          >
            {delta > 0 ? `+${delta}%` : `${delta}%`}
          </Typography>
        )} */}
      </Box>
      {/* <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          backgroundColor: "green",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img style={{ width: "100%" }} src={icons} alt="icons" />
      </Box> */}
    </Card>
  );
};

export default DashboardCard;
